export const CURRENT_EDIT_INAPP = 'CURRENT_EDIT_INAPP';
export const AUTHORIZED_GROUPS = 'authorizedGroups';
